export default "__VITE_ASSET__4db007e9__"